$(".close-promo").on("click", function () {
    $("#promotion-getnet").hide();
})